import gql from 'graphql-tag'

export const faqItemFragment = gql`
  fragment faqItem on FaqItem {
    id
    answer
    category
    question
  }
`
